<h2 class="text-uppercase sectionTitle" [i18n]="'regions.form.sub-sections.load-management'"></h2>
<label class="control-label" [i18n]="[{target: 'innerHTML', key: 'regions.form.features.carrier'}]"></label>
<small class="help-block m-b-xs m-t-none"
       [i18n]="[{target: 'innerHTML', key: 'regions.form.features.available.help'}]"></small>
<small class="help-block m-b-md" [i18n]="[{target: 'innerHTML', key: 'regions.form.features.forced.help'}]"></small>

<app-region-feature [groupName]="'loadTracking'"
                    [labelNode]="'feature-profiles.features.load-tracking'"
                    [(status)]="features.loadTracking">
</app-region-feature>
<app-region-feature [groupName]="'tmsLoadsSynchronization'"
                    [labelNode]="'feature-profiles.features.tms-loads-synchronization'"
                    [(status)]="features.tmsLoadsSynchronization"
                    (statusChange)="form.control.updateValueAndValidity()"></app-region-feature>
<app-region-feature-new [displayMode]="RegionFeatureDisplayMode.MULTI_SELECTION_MODE"
                        [groupName]="'driverAssignmentMode'"
                        [translationNode]="'feature-profiles.features.driver-assignment-mode'"
                        [(value)]="features.driverAssignmentModeValue"
                        [possibleValues]="driverAssignmentModes"
                        [regionFeature]="RegionFeature.DRIVER_ASSIGNMENT_MODE"
                        [regionId]="regionId"
                        [(overrideAbility)]="features.driverAssignmentModeOverrideAbility"></app-region-feature-new>
<app-region-feature-new [displayMode]="RegionFeatureDisplayMode.BOOLEAN_MODE"
                        [groupName]="'automaticTripCreation'"
                        [translationNode]="'feature-profiles.features.automatic-trip-creation'"
                        [(value)]="features.automaticTripCreationValue" [hideSeparator]="true"
                        [regionFeature]="RegionFeature.AUTOMATIC_TRIP_CREATION" [regionId]="regionId"
                        [(overrideAbility)]="features.automaticTripCreationOverrideAbility"
                        (valueChange)="form.control.updateValueAndValidity()"
                        (overrideAbilityChange)="form.control.updateValueAndValidity()">
    <ng-select [name]="'automaticTripCreationOrderTypes'"
               [multiple]="true"
               [clearable]="true"
               [bindValue]="'value'"
               [required]="features.automaticTripCreationValue"
               [(ngModel)]="features.automaticTripCreationOrderTypes"
               [disabled]="!features.automaticTripCreationValue"
               (change)="orderTypesChanged()">
        <ng-option *ngFor="let possibleValue of automaticTripCreationOrderTypes"
                   [value]="possibleValue.value"
                   [i18n]="possibleValue.labelKey">
        </ng-option>
    </ng-select>
    <span class="flex-row center-align space-top-10">
        <i class="fa fa-info-circle space-right-5"></i>
        <span [i18n]="[{target: 'innerHTML', key: 'feature-profiles.features.automatic-trip-creation.type-description'}]"></span>
    </span>
</app-region-feature-new>
<app-region-feature-new [displayMode]="RegionFeatureDisplayMode.INHERITED_ON_OFF_FEATURE_MODE"
                        [groupName]="'trip-created-webhook-enriched-data-feature'"
                        [translationNode]="'feature-profiles.features.trip-created-webhook-enriched-data-feature'"
                        [(value)]="features.tripCreatedWebhookEnrichedDataValue"
                        [regionFeature]="RegionFeature.TRIP_CREATED_WEBHOOK_ENRICHED_DATA_FEATURE"
                        [regionId]="regionId"
                        [hideSeparator]="true"
                        [(overrideAbility)]="features.tripCreatedWebhookEnrichedDataOverrideAbility">
</app-region-feature-new>

<div class="form-group" *ngIf="features.tmsLoadsSynchronization.available">
    <label class="control-label" [i18n]="'regions.form.tms-sync-time.label'"></label>
    <small class="help-block m-b-none" [i18n]="'regions.form.tms-sync-time.help'"></small>
    <ng-select
        [items]="regionTmsSyncScheduledTimes"
        [bindValue]="'value'"
        [bindLabel]="'label'"
        [name]="'tmssynctime'"
        [addTag]="false"
        [hideSelected]="false"
        [(ngModel)]="tmsSyncWindows"
        [multiple]="true">
    </ng-select>
</div>
<h2 class="text-uppercase sectionTitle" [i18n]="'regions.form.sub-sections.delivery-processing'"></h2>
<app-region-feature [groupName]="'multiDeliveries'" [labelNode]="'feature-profiles.features.multi-deliveries'"
                    [(status)]="features.multiDeliveries"></app-region-feature>
<app-region-feature [groupName]="'tipAndReload'" [labelNode]="'feature-profiles.features.tip-and-reload'"
                    [(status)]="features.tipAndReload"></app-region-feature>
<app-region-feature-new [displayMode]="RegionFeatureDisplayMode.BOOLEAN_MODE"
                        [groupName]="'dropAndHook'"
                        [translationNode]="'feature-profiles.features.drop-and-hook'"
                        [(value)]="features.dropAndHookValue"
                        [hideSeparator]="true"
                        [regionFeature]="RegionFeature.DROP_AND_HOOK"
                        [regionId]="regionId"
                        [(overrideAbility)]="features.dropAndHookOverrideAbility"></app-region-feature-new>
<app-region-feature [groupName]="'hotspotTracking'" [labelNode]="'feature-profiles.features.hotspot-tracking'"
                    [(status)]="features.hotspotTracking"></app-region-feature>
<app-region-feature [groupName]="'quantitiesUpdateTimer'"
                    [labelNode]="'feature-profiles.features.quantities-update-timer'"
                    [(status)]="features.quantitiesUpdateTimer"></app-region-feature>
<app-region-feature-new [displayMode]="RegionFeatureDisplayMode.INHERITED_ON_OFF_FEATURE_MODE"
                        [groupName]="'mrQuantityUpdateControl'"
                        [translationNode]="'feature-profiles.features.mr-quantity-update'"
                        [(value)]="features.mrDropQuantityUpdateControlValue"
                        [regionFeature]="RegionFeature.MR_QUANTITY_UPDATE"
                        [(overrideAbility)]="features.mrDropQuantityUpdateControlOverrideAbility"
                        [regionId]="regionId"
                        [hideSeparator]="true"></app-region-feature-new>
<app-region-feature-new [displayMode]="RegionFeatureDisplayMode.INHERITED_ON_OFF_FEATURE_MODE"
                        [groupName]="'sapMultiCollectionsCheckin'"
                        [translationNode]="'feature-profiles.features.sap-multicollection-checkin'"
                        [(value)]="features.sapMultiCollectionsCheckinValue"
                        [hideSeparator]="true"
                        [regionFeature]="RegionFeature.SAP_MULTI_COLLECTIONS_CHECKIN" [regionId]="regionId"
                        [(overrideAbility)]="features.sapMultiCollectionsOverrideAbility"
                        (valueChange)="sapMultiCollectionsCheckinValueChange()"></app-region-feature-new>
<app-region-feature-new [displayMode]="RegionFeatureDisplayMode.INHERITED_ON_OFF_FEATURE_MODE"
                        [groupName]="'sortLoadsByTripId'"
                        [translationNode]="'feature-profiles.features.sort-by-trip-id'"
                        [(value)]="features.sortLoadsByTripIdValue"
                        [hideSeparator]="true"
                        [regionFeature]="RegionFeature.SORT_LOADS_BY_TRIP_ID"
                        [regionId]="regionId"
                        [(overrideAbility)]="features.sortLoadsByTripIdOverrideAbility"></app-region-feature-new>
<app-region-feature [groupName]="'multiCollections'"
                    [labelNode]="'feature-profiles.features.multi-collections'"
                    [(status)]="features.multiCollections" style="display:none"></app-region-feature>

<app-region-feature-new [displayMode]="RegionFeatureDisplayMode.INHERITED_ON_OFF_FEATURE_MODE"
                        [groupName]="'sortStopsKeepingBYOrderId'"
                        [translationNode]="'feature-profiles.features.sort-stops-by-blueyonder-order'"
                        [(value)]="features.sortStopsByBlueyonderOrderValue"
                        [hideSeparator]="true"
                        [regionFeature]="RegionFeature.SORT_STOPS_BY_BLUEYONDER_ORDER" [regionId]="regionId"
                        [(overrideAbility)]="features.sortStopsByBlueyonderOrderOverrideAbility"></app-region-feature-new>

<h2 class="text-uppercase sectionTitle" [i18n]="'regions.form.sub-sections.cma'"></h2>
<app-region-feature [groupName]="'allowLoadsSearchFiltering'"
                    [labelNode]="'feature-profiles.features.allow-loads-search-filtering'"
                    [(status)]="features.allowLoadsSearchFiltering"></app-region-feature>
<app-region-feature [groupName]="'trailerYardManagement'"
                    [labelNode]="'feature-profiles.features.trailer-yard-management'"
                    [(status)]="features.trailerYardManagement"></app-region-feature>
<app-region-feature [groupName]="'cabinLicensePlate'"
                    [labelNode]="'feature-profiles.features.cabin-license-plate-required'"
                    [(status)]="features.cabinLicensePlateRequired"></app-region-feature>

<app-region-feature-new [displayMode]="RegionFeatureDisplayMode.MULTI_SELECTION_MODE"
                        [groupName]="'autoGroupCollection'"
                        [translationNode]="'feature-profiles.features.auto-group-collections'"
                        [(value)]="features.autoGroupCollectionsValue"
                        [possibleValues]="autoGroupCollections"
                        [hideSeparator]="true"
                        [regionFeature]="RegionFeature.AUTO_GROUP_COLLECTIONS"
                        [regionId]="regionId"
                        [(overrideAbility)]="features.autoGroupCollectionsOverrideAbility"></app-region-feature-new>

<app-region-feature [groupName]="'assetManagement'"
                    [labelNode]="'feature-profiles.features.asset-management'"
                    [(status)]="features.assetManagement"></app-region-feature>

<h2 class="text-uppercase sectionTitle"[i18n]="'regions.form.sub-sections.pod'"></h2>
<app-region-feature-new [displayMode]="RegionFeatureDisplayMode.MULTI_SELECTION_MODE"
                        [groupName]="'proofOfDeliveryRule'"
                        [translationNode]="'feature-profiles.features.proof-of-delivery-rule'"
                        [(value)]="features.proofOfDeliveryRuleValue"
                        [possibleValues]="proofOfDeliveryRules"
                        [hideSeparator]="true"
                        [regionFeature]="RegionFeature.PROOF_OF_DELIVERY_RULE" [regionId]="regionId"
                        [(overrideAbility)]="features.proofOfDeliveryRuleOverrideAbility">
</app-region-feature-new>
<app-region-feature-new [displayMode]="RegionFeatureDisplayMode.MULTI_SELECTION_MODE"
                        [groupName]="'photoProofOfDeliveryRule'"
                        [translationNode]="'feature-profiles.features.photo-proof-of-delivery-rule'"
                        [(value)]="features.photoPodRuleValue"
                        [possibleValues]="photoPodRules"
                        [(overrideAbility)]="features.photoPodRuleOverrideAbility"
                        [hideSeparator]="true"
                        [regionFeature]="RegionFeature.PHOTO_POD_RULE" [regionId]="regionId"
                        [disabled]="features.proofOfDeliveryRuleValue === ProofOfDeliveryRule.SIGNATURES"></app-region-feature-new>
<app-region-feature [groupName]="'sapSignaturesSending'"
                    [labelNode]="'feature-profiles.features.sap-signatures-sending'"
                    [(status)]="features.sapSignaturesSending"></app-region-feature>

<app-region-feature-new [displayMode]="RegionFeatureDisplayMode.BOOLEAN_MODE"
                        [groupName]="'multiAccounts'"
                        [translationNode]="'feature-profiles.features.multi-accounts'"
                        [(value)]="features.multiAccountsValue"
                        [(overrideAbility)]="features.multiAccountsOverrideAbility"
                        [hideSeparator]="true"
                        [regionFeature]="RegionFeature.MULTI_ACCOUNTS" [regionId]="regionId"
                        class="hidden">
</app-region-feature-new>

<app-data-filter-fieldSet [fieldsetTitleKey]="'feature-profiles.features.pod-validation.label'">
    <div class="space-top-10">
        <span><i class="fa fa-info-circle"></i>&nbsp;<span [i18n]="'feature-profiles.features.pod-validation.description'"></span></span><br><br>
        <app-region-feature-new [displayMode]="RegionFeatureDisplayMode.BOOLEAN_MODE"
                                [groupName]="'podValidationMrSync'"
                                [translationNode]="'feature-profiles.features.pod-validation.mr'"
                                [(value)]="features.podValidationMrSyncValue"
                                [possibleValues]="inheritableOnOffPossibleValues"
                                [(overrideAbility)]="features.podValidationMrSyncOverrideAbility"
                                [regionFeature]="RegionFeature.POD_VALIDATION_MR_SYNC"
                                [regionId]="regionId"
                                [hideSeparator]="true">
        </app-region-feature-new>

        <app-region-feature-new [displayMode]="RegionFeatureDisplayMode.BOOLEAN_MODE"
                                [groupName]="'podValidationManufacturerSync'"
                                [translationNode]="'feature-profiles.features.pod-validation.manufacturer'"
                                [(value)]="features.podValidationManufacturerSyncValue"
                                [regionFeature]="RegionFeature.POD_VALIDATION_MANUFACTURER_SYNC"
                                [regionId]="regionId"
                                [hideSeparator]="true"
                                [padding]="false"
                                [(overrideAbility)]="features.podValidationManufacturerSyncOverrideAbility">
        </app-region-feature-new>
    </div>
</app-data-filter-fieldSet>

<h2 class="text-uppercase sectionTitle" [i18n]="'regions.form.sub-sections.eta'"></h2>

<app-region-feature-new [displayMode]="RegionFeatureDisplayMode.INHERITED_ON_OFF_FEATURE_MODE"
                        [groupName]="'etaComputationControl'"
                        [translationNode]="'feature-profiles.features.eta-computation-control'"
                        [(value)]="features.etaComputationControlValue"
                        [regionFeature]="RegionFeature.ETA_COMPUTATION_CONTROL"
                        [(overrideAbility)]="features.etaComputationControlOverrideAbility"
                        [regionId]="regionId"
                        [hideSeparator]="true">
</app-region-feature-new>

<app-region-feature-new [displayMode]="RegionFeatureDisplayMode.INHERITED_ON_OFF_FEATURE_MODE"
                        [groupName]="'communicatePickEtaForMr'"
                        [translationNode]="'feature-profiles.features.communicate-pick-eta-for-mr'"
                        [(value)]="features.communicatePickEtaForMrValue"
                        [regionFeature]="RegionFeature.COMMUNICATE_PICK_ETA_FOR_MR"
                        [(overrideAbility)]="features.communicatePickEtaForMrOverrideAbility"
                        [regionId]="regionId"
                        [hideSeparator]="true"></app-region-feature-new>


<app-region-feature-new [displayMode]="RegionFeatureDisplayMode.INHERITED_ON_OFF_FEATURE_MODE"
                        [groupName]="'displayAutomaticEtaControl'"
                        [translationNode]="'feature-profiles.features.display-automatic-eta-control'"
                        [(value)]="features.displayAutomaticEtaControlValue"
                        [regionFeature]="RegionFeature.DISPLAY_AUTOMATIC_ETA_CONTROL"
                        [(overrideAbility)]="features.displayAutomaticEtaControlOverrideAbility"
                        [regionId]="regionId"
                        [hideSeparator]="true"></app-region-feature-new>

<app-region-feature-new [displayMode]="RegionFeatureDisplayMode.ON_OFF_FEATURE_MODE"
                        [groupName]="'usePcMilerHoS'"
                        [translationNode]="'feature-profiles.features.use-pcmiler-hos'"
                        [(value)]="features.pcMilerUseHosReportValue"
                        [regionId]="regionId"
                        [hideSeparator]="true"></app-region-feature-new>

<app-region-feature-new [displayMode]="RegionFeatureDisplayMode.INHERITED_ON_OFF_FEATURE_MODE"
                        [groupName]="'retrieveCarrierEtaFromBy'"
                        [translationNode]="'feature-profiles.features.retrieve-carrier-eta-from-by'"
                        [(value)]="features.retrieveCarrierEtaFromByValue"
                        [regionFeature]="RegionFeature.RETRIEVE_CARRIER_ETA_FROM_BY"
                        [(overrideAbility)]="features.retrieveCarrierEtaFromByOverrideAbility"
                        [regionId]="regionId"
                        [hideSeparator]="true"></app-region-feature-new>
